import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router-dom';
import {
  IoCodeSlashOutline as CodeSlashOutline,
  IoAppsOutline as AppsOutline,
  IoLayersOutline as LayersOutline,
  IoListOutline as ListOutline,
  IoGitNetworkOutline as GitNetworkOutline,
  IoGridOutline as PagesIcon,
  IoBookOutline as BookOutline,
  IoExtensionPuzzleOutline as ComponentIcon,
  IoCloudDownloadOutline as DataSourceIcon,
  IoCalculatorOutline as CalculatedIcon,
} from 'react-icons/io5';

export const LeftMenu = (props) => {
  const { t } = useTranslation('generator');

  return (
    <>
      <div className="sidebar-section-header">
        <CodeSlashOutline color='#ffffff' title={t('generator')} height="25px" width="25px" />
        <span className="sidebar-section-title">{t('generator')}</span>
      </div>
      <NavLink className="sidebar-item" to="/generator/application" onClick={props.onMobileClose}>
        <AppsOutline color='#ffffff' />
        <span className="sidebar-label">{t('applications')}</span>
      </NavLink>
      <NavLink className="sidebar-item" to="/generator/entity" onClick={props.onMobileClose}>
        <LayersOutline color='#ffffff' />
        <span className="sidebar-label">{t('entities')}</span>
      </NavLink>
      <NavLink className="sidebar-item" to="/generator/field" onClick={props.onMobileClose}>
        <ListOutline color='#ffffff' />
        <span className="sidebar-label">{t('fields')}</span>
      </NavLink>
      <NavLink className="sidebar-item" to="/generator/workflow" onClick={props.onMobileClose}>
        <GitNetworkOutline color='#ffffff' />
        <span className="sidebar-label">{t('workflow')}</span>
      </NavLink>
      <NavLink className="sidebar-item" to="/generator/pages" onClick={props.onMobileClose}>
        <PagesIcon color='#ffffff' />
        <span className="sidebar-label">{t('pages', 'Pages')}</span>
      </NavLink>
      <NavLink className="sidebar-item" to="/generator/components" onClick={props.onMobileClose}>
        <ComponentIcon color='#ffffff' />
        <span className="sidebar-label">
          {props.user?.is_reviewer ? t('custom-components', 'Custom Components') : t('my-components', 'My Components')}
        </span>
      </NavLink>
      <NavLink className="sidebar-item" to="/generator/data-sources" onClick={props.onMobileClose}>
        <DataSourceIcon color='#ffffff' />
        <span className="sidebar-label">{t('data-sources', 'Data sources')}</span>
      </NavLink>
      <NavLink className="sidebar-item" to="/generator/calculated-tables" onClick={props.onMobileClose}>
        <CalculatedIcon color='#ffffff' />
        <span className="sidebar-label">{t('calculated-tables', 'Calculated tables')}</span>
      </NavLink>
      <NavLink className="sidebar-item" to="/generator/docs" onClick={props.onMobileClose}>
        <BookOutline color='#ffffff' />
        <span className="sidebar-label">{t('documentation')}</span>
      </NavLink>      
    </>
  );
};
